export default __webpack_public_path__ + "static/media/gleam.b7d3302b.svg";